import { z } from 'zod'

import { ConfigurationAdminBreakersZod } from './configuration-admin-breakers-zod'
import { ConfigurationAutomatedAssignmentMinutesZod } from './configuration-automated-assignment-minutes-zod'
import { ConfigurationAutomatedAssignmentZod } from './configuration-automated-assignment-zod'
import { ConfigurationCallGatewayZod } from './configuration-call-gateway-zod'
import { ConfigurationEnabledAutomationTestRegionZod } from './configuration-enabled-automation-test-region-zod'
import { ConfigurationExcludedPhoneNumbersZod } from './configuration-excluded-phone-numbers-zod'
import { ConfigurationJudicialZod } from './configuration-judicial-zod'
import { ConfigurationMilestoneZod } from './configuration-milestone-zod'
import { ConfigurationPromotionsZod } from './configuration-promotions-zod'
import { ConfigurationRegistrationZod } from './configuration-registration-zod'
import { ConfigurationSupportLlmZod } from './configuration-support-llm-zod'
import { ConfigurationSupportSlackZod } from './configuration-support-slack-zod'
import { ConfigurationTransportRequestContraintsZod } from './configuration-transport-request-contraints-zod'

export const ConfigurationZod = z.discriminatedUnion('_id', [
  ConfigurationTransportRequestContraintsZod.extend({ _id: z.literal('TransportRequestConstraints') }),
  ConfigurationAutomatedAssignmentZod.extend({ _id: z.literal('AutomatedAssignment') }),
  ConfigurationAutomatedAssignmentMinutesZod.extend({ _id: z.literal('AutomatedAssignmentMinutes') }),
  ConfigurationAdminBreakersZod.extend({ _id: z.literal('AdminBreakers') }),
  ConfigurationRegistrationZod.extend({ _id: z.literal('Registration') }),
  ConfigurationMilestoneZod.extend({ _id: z.literal('Milestone') }),
  ConfigurationExcludedPhoneNumbersZod.extend({ _id: z.literal('ExcludedPhoneNumbers') }),
  ConfigurationPromotionsZod.extend({ _id: z.literal('Promotions') }),
  ConfigurationJudicialZod.extend({ _id: z.literal('Judicial') }),
  ConfigurationEnabledAutomationTestRegionZod.extend({ _id: z.literal('EnabledAutomationTestRegion') }),
  ConfigurationSupportLlmZod.extend({ _id: z.literal('SupportLlm') }),
  ConfigurationSupportSlackZod.extend({ _id: z.literal('SupportSlack') }),
  ConfigurationCallGatewayZod.extend({ _id: z.literal('CallGateway') }),
])
